import type { Rng } from './contracts'

/**
 * Детерминированный ГСЧ (mulberry32).
 * Нужен, чтобы раунды воспроизводились в тестах: один seed = один результат.
 * Math.random в играх запрещён - только через этот интерфейс.
 */
export function createRng(seed: number): Rng {
  let state = seed >>> 0

  const next = (): number => {
    state = (state + 0x6d2b79f5) >>> 0
    let t = state
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }

  return {
    next,
    int: (max) => Math.floor(next() * max),
    pick<T>(items: readonly T[]): T {
      if (items.length === 0) throw new Error('rng.pick: пустой массив')
      const item = items[Math.floor(next() * items.length)]
      if (item === undefined) throw new Error('rng.pick: индекс вне диапазона')
      return item
    },
    shuffle<T>(items: readonly T[]): T[] {
      const out = [...items]
      for (let i = out.length - 1; i > 0; i--) {
        const j = Math.floor(next() * (i + 1))
        const a = out[i]
        const b = out[j]
        if (a === undefined || b === undefined) continue
        out[i] = b
        out[j] = a
      }
      return out
    },
  }
}

/** Seed из даты - одинаковая тренировка дня у пользователя в течение суток. */
export function seedFromDate(date: Date = new Date()): number {
  return date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate()
}
